module.exports = __webpack_public_path__ + "img/half4.0e897c7.png";